<div class="container single-view" id="add-collection">
  <div class="row">
    <div class="col-12 mb-6 flex flex-wrap items-end justify-between gap-4">
      <div id="pre-header-wr">
        <a data-testid="back-btn" routerLink="/collections/" class="inline-flex items-center text-base link link-icon left-arrow">{{ 'COLLECTIONS.BTN_BACK_TO_COLLECTION' | translate }}</a>
      </div>
    </div>
    <div class="col-12">
      <div id="view-header-wr" class="flex flex-wrap items-end justify-between gap-4">
        <div class="title-wr">
          <h1 data-testid="add-collection-create-collection-title" class="section-title">{{ 'COLLECTION_CREATE.TITLE' | translate }}</h1>
          <p data-testid="add-collection-create-collection-title" class="section-subtitle mt-1 text-base">{{ 'COLLECTION_CREATE.SUBTITLE' | translate }}</p>
        </div>
        <div class="actions-wr"></div>
      </div>
      <hr role="presentation" class="w-full mb-3 mt-6 border-t">
      <div class="view-content-wr">
        <div class="row">
          <div class="flex flex-col col-12 mb-2 text-wr">
            <!-- main content -->
            <form data-testid="add-collection-create-collection-form" class="mt-0" [formGroup]="collectionForm">
              <div class="row">
                <div class="flex flex-col col-12 mb-4">
                  <h2 data-testid="add-collections-details-title" class="border-b pb-3">{{ 'COLLECTION_CREATE.COLLECTION_DETAILS' | translate }}</h2>
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                  <label data-testid="add-collection-field-name" class="block text-sm" for="name">{{ 'COLLECTION_CREATE.NAME' | translate }} <i class="icon-required-field"></i> </label>
                  <input data-testid="add-collection-name-input" type="text" id="name" formControlName="name" autocomplete="off">
                  @if (collectionForm.get('name')?.invalid && collectionForm.get('name')?.touched) {
                    <small data-testid="name-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                  }
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                  <label data-testid="add-collection-field-code" class="block text-sm" for="code">{{ 'COLLECTION_CREATE.CODE' | translate }} <i class="icon-required-field"></i></label>
                  <input data-testid="add-collection-code-input" type="text" id="code" formControlName="code" autocomplete="off">
                  @if (collectionForm.get('code')?.invalid && collectionForm.get('code')?.touched) {
                    <small data-testid="code-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                  }
                </div>
                <div class="field-wr col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                  <span data-testid="add-collection-field-hasParent" class="block text-sm mb-3" for="hasParentCollection">{{ 'COLLECTION_CREATE.HAS_PARENT' | translate }}</span>
                  <label data-testid="add-collection-has-parent-yes-label" class="inline-flex mr-6">
                    <p-radioButton data-testid="add-collection-has-parent-yes" name="hasParentCollection" value="true" formControlName="hasParentCollection" inputId="yes" />
                    <span for="yes" class="ml-2">{{ 'BOOLEANS.YES' | translate }}</span>
                  </label>
                  <label data-testid="add-collection-has-parent-no-label" class="inline-flex mr-2">
                    <p-radioButton data-testid="add-collection-has-parent-no" name="hasParentCollection" value="false" formControlName="hasParentCollection" inputId="no" />
                    <span for="no" class="ml-2">{{ 'BOOLEANS.NO' | translate }}</span>
                  </label>
                </div>
                <div data-testid="add-collection-field-parent-collection"  class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3"
                  [ngClass]="{'disabled': collectionForm.get('hasParentCollection')?.value == 'false'}">
                  <label class="block text-sm" for="collectionId">{{ 'COLLECTION_CREATE.PARENT_COLLECTION' | translate }}</label>
                  <app-custom-dropdown
                    data-testid="parentcollection"
                    [placeholder]="'COLLECTION_CREATE.SELECT_PARENT_PLACEHOLDER' | translate"
                    optionLabel="text"
                    optionValue="id"
                    [isMultiselect]="false"
                    [showSelectionChips]="true"
                    [showClear]="true"
                    [searchMode]="'remote'"
                    [pageSize]="comboData.rowsPerPageOption || 5"
                    [totalCount]="comboData.totalRecords"
                    [totalPages]="getComboTotalPages()"
                    [options]="comboData.list"
                    formControlName="collectionId"
                    (onLazyLoad)="onLazyLoadComboData($event)">
                  </app-custom-dropdown>
                  @if (collectionForm.errors?.['requiredCollection'] && isCollectionRequired()) {
                    <small data-testid="parent-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                  }
                </div>
              </div>
              <div class="row">
                <div class="col-12 mt-6 mb-4 pt-8 border-t">
                  <div class="flex items-center justify-end gap-3">
                    <button data-testid="add-collection-create-collection-button" class="btn primary-btn" [disabled]="collectionForm.invalid"
                      (click)="submitForm()">{{
                    'COLLECTION_CREATE.BTN_CREATE_COLLECTION' | translate }}</button>
                  </div>
                </div>
              </div>
            </form>
            <!-- /main content -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
